import React from 'react';
import PropTypes from 'prop-types';
import AccountContentWrapper from '../Account/AccountContentWrapper';
import ChangeAccountDetails from '../Account/ChangeAccountDetails';
import './Page.css';

export default function AccountUserDetails(props) {
  return (
    <AccountContentWrapper
      locale={props.locale}
      setLocale={props.setLocale}
      services={props.services}
      dataStorage={props.dataStorage}
      setDataStorage={props.setDataStorage}
    >
      <ChangeAccountDetails
        locale={props.locale}
        services={props.services}
        dataStorage={props.dataStorage}
        setDataStorage={props.setDataStorage}
      />
    </AccountContentWrapper>
  );
}

AccountUserDetails.propTypes = {
  locale: PropTypes.string.isRequired,
  setLocale: PropTypes.func.isRequired,
  services: PropTypes.objectOf(PropTypes.object).isRequired,
  dataStorage: PropTypes.objectOf(PropTypes.any).isRequired,
  setDataStorage: PropTypes.func.isRequired,
};
